/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/no-use-before-define */
/**
 *
 * InputFilter
 *
 */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
// import { debounce } from 'lodash';

import { Icon, Text, Input } from 'components/common';

import styles from './style.module.css';
import RichInput from '../RichInput';

function InputFilter({
  filter,
  advance,
  hasError,
  selectedValues = '',
  onFilterApplied,
  handleRemoveAdvanceFilter,
}: any) {
  /**
   * trims out array elements and joins them together with commas.
   */
  const getInputValue = useCallback(
    (list) =>
      advance && Array.isArray(list)
        ? list
            .filter((e) => e.trim())
            .map((e) => e.trim())
            .join(',')
        : list,
    [advance],
  );

  const [inputText, setInputText] = useState(getInputValue(selectedValues));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedCallback = useCallback(
    // debounce(value => onInputChange(value), 200),
    (value) => onInputChange(value),
    [],
  );

  const inputRef = useRef<any>(null);

  useEffect(() => {
    const newVal = getInputValue(selectedValues);
    setInputText(newVal);
  }, [selectedValues, getInputValue]);

  useEffect(() => {
    if (hasError?.length)
      inputRef.current?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      });
  }, [hasError]);

  /**
   * * Split to make array -> filter empty strings -> remove white-spaces in list elements
   */
  const onInputChange = (value: any) => {
    onFilterApplied(
      filter.key,
      advance
        ? value
            .split(',')
            .filter((e: any) => e.trim())
            .map((e: any) => e.trim())
        : value,
    );
  };

  return (
    <div className={styles.container}>
      <Text type="subtitle" text={filter.name} />

      <div className={styles.inputFilterBox} ref={inputRef}>
        {advance ? (
          <RichInput
            hasError={hasError}
            placeholder="Enter a comma separated list"
            defaultValue={inputText}
            onChange={debouncedCallback}
            onBlur={onInputChange}
            backgroundColor="#0215290c"
            height={43}
          />
        ) : (
          <Input
            className="input-box"
            value={inputText}
            placeholder="Will search exact match only"
            onChange={onInputChange}
            onBlur={onInputChange}
          />
        )}
        {advance && (
          <Icon
            size={12}
            className="cursor-pointer"
            type="delete"
            onClick={() => {
              handleRemoveAdvanceFilter(filter.field);
            }}
          />
        )}
      </div>
      {hasError?.length ? (
        <div className="advance-input-filter-error">
          <Text
            type="subtitle"
            className="ptp-red"
            text="The entered input appears to be invalid"
          />
        </div>
      ) : null}
    </div>
  );
}

export default InputFilter;
